import { useMemo } from "react"
import { useTranslation } from "react-i18next";
import { useReduxSelector } from "@hooks/useReduxSelector";
import { useNotification } from "@hooks/useNotification";
import { GenderTypeService } from "@services/all.services";
import { GENDER_LIST } from "../employeForm-constants";

const useGenderType = () => {
    const genderTypes = useReduxSelector(
        ({ enterpriseEmployeData: { genderType } }) => genderType?.list
    );
    const { t } = useTranslation([
        "pages.employés.infoPers",
        "pages.employés.importation",
        "pipelines.pipeline",
        "pages.employés.statistics"
    ]);
    const allGenderTypes = useMemo(() => {
        const translatedGENDER_LIST = GENDER_LIST.map(gender => ({
            name: t(gender._id),
            _id: gender._id
        }));

        const formattedGenderTypes = (genderTypes || []).map(gender => ({
            name: gender.name,
            _id: gender.name
        }));

        return [...translatedGENDER_LIST, ...formattedGenderTypes];
    }, [t, genderTypes]);

    const enterpriseId = useReduxSelector((state) => state.userConnected.Enterprise);
    const { showSuccess, showError } = useNotification();

    const addGenderType = async (formValue) => {
        if (!enterpriseId) return true;

        const payload = {
            name: formValue.name,
            Enterprise: enterpriseId
        };

        const response = (await GenderTypeService.insert(payload))?.data?.data;

        if (!response) return showError("error");
        if (response === "FORBIDDEN") return showError("already_exists", { object: "genderUpper" });

        showSuccess("creation_action_success", { object: "genderLower" });
        return false;
    };

    const updateGenderType = async (formValue) => {
        if (!enterpriseId) return true;

        const payload = {
            ...formValue,
            _id: formValue?._id,
            Enterprise: enterpriseId
        };

        const response = (await GenderTypeService.updateById(payload, { enterpriseId }))?.data?.data;

        if (!response) return showError("error");
        if (response === "FORBIDDEN") return showError("already_exists", { object: "genderUpper" });

        showSuccess("update_action_success", { object: "genderLower" });
        return false;
    };

    const deleteGenderType = async (formValue) => {
        if (!enterpriseId) return true;

        const response = (await GenderTypeService.deleteById(formValue?._id, { enterpriseId }))?.data?.data;

        if (!response) return showError("error");
        if (response === "FORBIDDEN") return showError("already_used", { object1: "genderUpper", object2: "employee" });
        
        showSuccess("delete_action_success", { object: "genderLower" });
        return false;
    };

    return {
        genderTypes,
        addGenderType,
        updateGenderType,
        deleteGenderType,
        allGenderTypes
    };
};

export default useGenderType;